<template>
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-title">{{languages.rmind}}</div>
      <div class="confirm-content">{{languages.remindTips}}</div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button class="btn-cancel"
                 :disabled="submitting"
                 @click="Hide">{{languages.cancel}}
      </el-button>
      <el-button class="btn-confirm"
                 type="primary"
                 :loading="submitting"
                 @click="Remind">{{languages.conRemind}}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    languages: Object,
    show: Boolean,
    submitting: Boolean,
  },
  methods: {
    Hide () {
      this.$parent.hideRemindDialog();
    },
    Remind () {
      this.$parent.handleRemind();
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
.confirm-content {
  margin-top: 10px;
}
.btn-cancel,
.btn-confirm {
  width: 90px;
  height: 30px;
  border-radius: 2px;
  line-height: 22px;
}
</style>
